export default "__VITE_ASSET__F6V8zjXb__"